export default __webpack_public_path__ + "static/media/illustration-study-1-w.7973fb95.webp";